import Wrap from './styles';

import AppContext from '@map/services/context';
import ListItem from '@material-ui/core/ListItem';
/**
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 */
import { useContext } from 'react';

const SideBarNav = (props) => {
  const context = useContext(AppContext);

  /**
   * @returns Icones da sidebar lateral no MOBILE
   * login: icone de uma pessoa
   * modulos: icone de 4 quadrado
   * contato: icone de carta
   */
  return (
    <Wrap>
      <ListItem button onClick={(e) => context.openSideBar('login')}>
        <svg
          width="15"
          height="17"
          viewBox="0 0 15 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.27945 8.18018C5.07031 8.18018 3.27945 6.38932 3.27945 4.18018C3.27945 1.97104 5.07031 0.180176 7.27945 0.180176C9.48859 0.180176 11.2794 1.97104 11.2794 4.18018C11.2794 6.38932 9.48859 8.18018 7.27945 8.18018ZM7.27945 7.38018C9.04676 7.38018 10.4794 5.94749 10.4794 4.18018C10.4794 2.41286 9.04676 0.980176 7.27945 0.980176C5.51214 0.980176 4.07945 2.41286 4.07945 4.18018C4.07945 5.94749 5.51214 7.38018 7.27945 7.38018Z"
            fill="#5E6366"
          />
          <path
            d="M0.0794525 13.3802C0.0794525 10.9501 2.0494 8.98016 4.47945 8.98016H10.0795C12.5095 8.98016 14.4795 10.9501 14.4795 13.3802V15.7802C14.4795 16.0011 14.3004 16.1802 14.0795 16.1802H0.479453C0.258539 16.1802 0.0794525 16.0011 0.0794525 15.7802L0.0794525 13.3802ZM13.6795 13.3802C13.6795 11.3919 12.0677 9.78016 10.0795 9.78016H4.47945C2.49123 9.78016 0.879453 11.3919 0.879453 13.3802V15.3802H13.6795V13.3802Z"
            fill="#5E6366"
          />
        </svg>{' '}
        Login
      </ListItem>
      <ListItem button onClick={(e) => context.openSideBar('select-modules')}>
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.43137 0.133942C0.687696 0.133942 0.0794525 0.738756 0.0794525 1.48757V5.29886C0.0794525 6.04768 0.687696 6.6525 1.43137 6.6525H5.17889C5.92256 6.6525 6.53081 6.04768 6.53081 5.29886V1.48757C6.53081 0.738756 5.92256 0.133942 5.17889 0.133942H1.43137ZM9.38002 0.133942C8.63634 0.133942 8.0281 0.738756 8.0281 1.48757V5.29886C8.0281 6.04768 8.63634 6.6525 9.38002 6.6525H13.1275C13.8712 6.6525 14.4795 6.04768 14.4795 5.29886V1.48757C14.4795 0.738756 13.8712 0.133942 13.1275 0.133942H9.38002ZM1.43137 0.681155H5.17889C5.63284 0.681155 5.99011 1.03636 5.99011 1.48757V5.29886C5.99011 5.75008 5.63284 6.10528 5.17889 6.10528H1.43137C0.97776 6.10528 0.620494 5.75008 0.620494 5.29886V1.48757C0.620494 1.03636 0.97776 0.681155 1.43137 0.681155ZM9.38002 0.681155H13.1275C13.5811 0.681155 13.9388 1.03636 13.9388 1.48757V5.29886C13.9388 5.75008 13.5811 6.10528 13.1275 6.10528H9.38002C8.92606 6.10528 8.5688 5.75008 8.5688 5.29886V1.48757C8.56845 1.03636 8.92572 0.681155 9.38002 0.681155ZM1.43137 7.71744C0.687696 7.71744 0.0794525 8.32259 0.0794525 9.06147V12.8824C0.0794525 13.6216 0.687696 14.2264 1.43137 14.2264H5.17889C5.92256 14.2264 6.53081 13.6216 6.53081 12.8824V9.06147C6.53081 8.32259 5.92256 7.71744 5.17889 7.71744H1.43137ZM9.38002 7.71744C8.63634 7.71744 8.0281 8.32259 8.0281 9.06147V12.8824C8.0281 13.6216 8.63634 14.2264 9.38002 14.2264H13.1275C13.8712 14.2264 14.4795 13.6216 14.4795 12.8824V9.06147C14.4795 8.32259 13.8712 7.71744 13.1275 7.71744H9.38002ZM1.43137 8.25539H5.17889C5.63284 8.25539 5.99011 8.6106 5.99011 9.06181V12.8824C5.99011 13.3336 5.63284 13.6792 5.17889 13.6792H1.43137C0.97776 13.6792 0.620494 13.3336 0.620494 12.8824V9.06147C0.620494 8.6106 0.97776 8.25539 1.43137 8.25539ZM9.38002 8.25539H13.1275C13.5811 8.25539 13.9388 8.6106 13.9388 9.06181V12.8824C13.9388 13.3336 13.5811 13.6792 13.1275 13.6792H9.38002C8.92606 13.6792 8.5688 13.3336 8.5688 12.8824V9.06147C8.56845 8.6106 8.92572 8.25539 9.38002 8.25539Z"
            fill="#5E6366"
          />
        </svg>{' '}
        Módulos
      </ListItem>
      <ListItem button onClick={(e) => context.openSideBar('contact')}>
        <svg
          width="16"
          height="12"
          viewBox="0 0 16 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.84763 11.6111H13.7113C14.8476 11.6111 15.7794 10.6793 15.7794 9.54292V2.90656C15.7794 1.7702 14.8476 0.838379 13.7113 0.838379H2.84763C1.71127 0.838379 0.779449 1.7702 0.779449 2.90656V9.54292C0.802177 10.6793 1.71127 11.6111 2.84763 11.6111ZM1.34763 2.90656C1.34763 2.06565 2.02945 1.40656 2.84763 1.40656H13.7113C14.5522 1.40656 15.2113 2.08838 15.2113 2.90656V9.54292C15.2113 10.3838 14.5295 11.0429 13.7113 11.0429H7.5749H2.84763C2.00672 11.0429 1.34763 10.3611 1.34763 9.54292V2.90656ZM2.984 9.08838L6.46127 6.0202L3.00672 3.33838C2.89309 3.24747 2.87036 3.06565 2.96127 2.95202C3.05218 2.83838 3.23399 2.81565 3.34763 2.90656L8.30218 6.74747L13.234 2.88383C13.3476 2.79292 13.5294 2.81565 13.6204 2.92929C13.7113 3.04292 13.6885 3.22474 13.5749 3.31565L10.1658 5.99747L13.6204 9.08838C13.734 9.20201 13.734 9.36111 13.6431 9.47474C13.5976 9.54293 13.5067 9.56565 13.4385 9.56565C13.3704 9.56565 13.3022 9.54292 13.2567 9.49747L9.71127 6.33838L8.46127 7.31565C8.41581 7.36111 8.34763 7.38383 8.30218 7.38383C8.25672 7.38383 8.18854 7.36111 8.14309 7.31565L6.93854 6.38383L3.34763 9.49747C3.30218 9.54292 3.23399 9.56565 3.16581 9.56565C3.09763 9.56565 3.00672 9.54293 2.96127 9.47474C2.87036 9.36111 2.87036 9.17929 2.984 9.08838Z"
            fill="#5E6366"
          />
        </svg>{' '}
        Contato
      </ListItem>
    </Wrap>
  );
};

export default SideBarNav;
